import BaseService from "./base.service";

export default class DownloadsCategoriesService extends BaseService {
	constructor() {
		super("multimidia/materiais/categorias");
	}
}
